export const VIEW_MORE_DESCRIPTION_SELECTOR = "#view-more-description";
export const VIEW_LESS_DESCRIPTION_SELECTOR = "#view-less-description";
export const DESCRIPTION_TEXT_SELECTOR = "#description-text";
export const DESCRIPTION_TEXT_FULL_SELECTOR = "#description-text-full";
export const EXPANDED_CLASS = "expanded";
export const HIDDEN_CLASS = "hidden";

